import type { Group, Mesh, Object3D, ShaderMaterial, Vector3 } from '@anov/3d-core'
import _ from 'lodash'
import { Color, use } from '@anov/3d-core'
import ObjectLayer from '../../Base/ObjectLayer'
import type { FenceOption } from '../type'
import { hexToRGBA, parseRGBA } from '../tool'

class FenceBase extends ObjectLayer {
  public _mesh!: Mesh
  public _height: number
  public _alpha: number
  public _color: string
  public _corner: number
  public _close: boolean
  public _points!: Vector3[]
  public _uri: string
  public _option: FenceOption
  public _listeners = new Set()

  private _areaInstance: any
  constructor(option: FenceOption, _areaInstance: any) {
    super(_areaInstance.sceneControl)
    this._option = option
    // 属性赋值
    this._initParams(option)
    this._areaInstance = _areaInstance
    // this.setValues(_.mergeWith({}, defaultOption, option))
  }

  public get mesh() {
    return this._mesh
  }

  public get uri() {
    return this._uri
  }

  public set uri(value: string) {
    if (this._uri === value)
      return
    this._uri = value
    // eslint-disable-next-line max-statements-per-line
    this._listeners.forEach((cb: Function) => { cb.call(this._areaInstance) })
  }

  // Getter and Setter for fenceHeight property
  get height(): number {
    return this._height
  }

  set height(newValue: number) {
    if (this._height === newValue)
      return

    this._height = newValue

    // eslint-disable-next-line max-statements-per-line
    this._listeners.forEach((cb: Function) => { cb.call(this._areaInstance) })
    // if (this._mesh) {
    //   const childrens = this._mesh.children
    //   childrens.forEach((item, index) => {
    //     const uniforms = ((item as Mesh).material as ShaderMaterial).uniforms
    //     if (uniforms.height)
    //       uniforms.height.value = newValue
    //   })
    // }
  }

  // Getter and Setter for fenceColor property
  get color(): string {
    return this._color
  }

  set color(newValue: string) {
    if (this._color === newValue)
      return

    this._color = newValue
    if (this._mesh) {
      // const childrens = this._mesh.children
      // const childrens = this._mesh.children
      // childrens.forEach((item, index) => {
      //   const uniforms = ((item as Mesh).material as ShaderMaterial).uniforms
      //   if (uniforms.color1) {
      //     const { r, g, b } = parseRGBA(hexToRGBA(newValue))
      //     const colorTemp = { r: Number((Number(r) / 255).toFixed(4)), g: Number((Number(g) / 255).toFixed(4)), b: Number((Number(b) / 255).toFixed(4)) }
      //     uniforms.color1.value = colorTemp
      //   }

      //   // uniforms.color2.value = new Color(newValue)
      // })
      // childrens.forEach((item, index) => {
      const uniforms = ((this._mesh as Mesh).material as ShaderMaterial).uniforms
      if (uniforms.color1) {
        const { r, g, b } = parseRGBA(hexToRGBA(newValue))
        const colorTemp = { r: Number((Number(r) / 255).toFixed(4)), g: Number((Number(g) / 255).toFixed(4)), b: Number((Number(b) / 255).toFixed(4)) }
        uniforms.color1.value = colorTemp
      }

      // uniforms.color2.value = new Color(newValue)
      // })
    }
  }

  // Getter and Setter for fenceAlpha property
  get alpha(): number {
    return this._alpha
  }

  set alpha(newValue: number) {
    if (this._alpha === newValue)
      return

    this._alpha = newValue
    if (this._mesh) {
      // const childrens = this._mesh.children
      // childrens.forEach((item, index) => {
      //   const uniforms = ((item as Mesh).material as ShaderMaterial).uniforms
      //   if (uniforms.alpha)
      //     uniforms.alpha.value = newValue
      // })
      // childrens.forEach((item, index) => {
      const uniforms = ((this._mesh as Mesh).material as ShaderMaterial).uniforms
      if (uniforms.alpha)
        uniforms.alpha.value = newValue
      // })
    }
  }

  get corner(): number {
    return this._corner
  }

  set corner(newValue: number) {
    if (this._corner === newValue)
      return

    this._corner = newValue
  }

  get close(): boolean {
    return this._close
  }

  set close(newValue: boolean) {
    if (this._close === newValue)
      return

    this._close = newValue
  }

  _initParams(option: FenceOption) {
    this._alpha = option.alpha
    this._corner = option.corner
    this._close = option.close
    this._height = option.height
    this._color = option.color
    this._points = option.points as unknown as Vector3[]
    this._uri = option.uri
  }

  public delete() {
    this._mesh.remove()
    this._mesh.removeFromParent()
  }

  // 销毁
  public dispose() {
    this.delete()
    this._listeners.clear()
  }

  // 注册监听
  public addReloadListener(callback: Function) {
    this._listeners.add(callback)
  }
}

export default FenceBase
